import { useEffect } from 'react';

const AI_VARS: Record<string, string> = {
  '--ai-assistant-color-primary': '#0891B2',
  '--ai-assistant-color-primary-light': '#43B4D6',
  '--ai-assistant-color-primary-dark': '#065F73',
  '--ai-assistant-color-primary-a10': 'rgba(8,145,178,0.1)',
  '--ai-assistant-color-primary-a12': 'rgba(8,145,178,0.12)',
  '--ai-assistant-color-primary-a15': 'rgba(8,145,178,0.15)',
  '--ai-assistant-color-primary-a20': 'rgba(8,145,178,0.2)',
  '--ai-assistant-color-primary-a25': 'rgba(8,145,178,0.25)',
  '--ai-assistant-color-primary-a30': 'rgba(8,145,178,0.3)',
  '--ai-assistant-color-primary-a40': 'rgba(8,145,178,0.4)',
  '--ai-assistant-color-primary-a50': 'rgba(8,145,178,0.5)',
  '--ai-assistant-color-primary-a60': 'rgba(8,145,178,0.6)',
  '--ai-assistant-color-primary-a70': 'rgba(8,145,178,0.7)',
  '--ai-assistant-color-primary-dark-a15': 'rgba(6,95,115,0.15)',
  '--ai-assistant-color-primary-dark-a20': 'rgba(6,95,115,0.2)',
  '--ai-assistant-color-secondary': '#BE185D',
  '--ai-assistant-color-secondary-a15': 'rgba(190,24,93,0.15)',
  '--ai-assistant-color-secondary-a20': 'rgba(190,24,93,0.2)',
  '--ai-assistant-color-secondary-a25': 'rgba(190,24,93,0.25)',
  '--ai-assistant-color-secondary-a30': 'rgba(190,24,93,0.3)',
  '--ai-assistant-color-accent': '#0891B2',
  '--ai-assistant-color-hover-bg': 'rgba(8,145,178,0.15)',
  '--ai-assistant-color-hover-bg-light': 'rgba(8,145,178,0.1)',
  '--ai-assistant-color-active-border': 'rgba(8,145,178,0.3)',
  '--ai-assistant-shadow-glow': '0 4px 20px rgba(8,145,178,0.4)',
  '--ai-assistant-shadow-glow-lg': '0 8px 30px rgba(8,145,178,0.5)',
};

/** Adds `orion-ui` class to <body> and sets AI assistant theme vars on :root. */
export const AppThemeGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    const root = document.documentElement;
    document.body.classList.add('orion-ui');
    Object.entries(AI_VARS).forEach(([k, v]) => root.style.setProperty(k, v, 'important'));
    return () => {
      document.body.classList.remove('orion-ui');
      Object.keys(AI_VARS).forEach((k) => root.style.removeProperty(k));
    };
  }, []);

  return <>{children}</>;
};
